import { axiosInstance } from 'config';
import { DocumentsTypeResponse } from './document-types.model';

class DocumentTypesAPI {
  getDocTypes(preventTypes?: string[]) {
    return axiosInstance
      .get<DocumentsTypeResponse>('/servicios_fijos/v1/document_types')
      .then(({ data: { documentsType } }) => {
        if (!preventTypes) return documentsType;
        return documentsType.filter((type) => !preventTypes.includes(type.id));
      });
  }
}

export default new DocumentTypesAPI();
